import styled from 'styled-components';
import { MediaContainer as MediaContainerComponent } from '@elfsight/widget-media';
import type { DefaultComponentProps } from '../../../types';

interface MediaContainerProps extends DefaultComponentProps {
  ratio?: number;
  backgroundImage?: string;
  backgroundColor?: string;
}

function _Container({
  children,
  ratio,
  backgroundImage,
  backgroundColor = '#000',
  ...forwardingProps
}: MediaContainerProps) {
  return (
    <MediaContainerComponent
      {...forwardingProps}
      ratio={ratio}
      backgroundImage={backgroundImage}
      backgroundColor={backgroundColor}
    >
      {children}
    </MediaContainerComponent>
  );
}

export const MediaContainer = styled(_Container)``;
